module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag45_2157AT.30ebfae8.jpg";